import {useEffect, lazy, Suspense} from 'react';
import * as React from 'react';
import './App.css';
import CookieConsent, {Cookies, getCookieConsentValue,} from "react-cookie-consent";
import firebase from "firebase/app";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import WelcomeBanner from "./components/data/welcomeBanner";
import GalleryStrip from "./components/data/galleryStrip";
import ContactSection from "./components/data/contactSection";

const AdminPage = lazy(() => import("./components/admin/adminPage"));
const ValidatePage = lazy(() => import("./components/validate/ValidatePage"));

function App() {

    const handleAcceptCookie = () => {
        firebase.analytics();
    };

    const handleDeclineCookie = () => {
        // remove google analytics cookies
        Cookies.remove("_ga");
        Cookies.remove("_gat");
        Cookies.remove("_gid")
    };

    useEffect(() => {
        const isConsent = getCookieConsentValue();
        if (isConsent === "true") {
            handleAcceptCookie();
        }
    }, []);

    // @ts-ignore
    return (
        <div className="dark-theme App-wrapper">
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/admin" element={
                            <Suspense fallback={<div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>Loading…</div>}>
                                <AdminPage />
                            </Suspense>
                        } />
                        <Route path="/validate" element={
                            <Suspense fallback={<div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>Loading…</div>}>
                                <ValidatePage />
                            </Suspense>
                        } />
                        <Route path="*" element={<div>
                            <WelcomeBanner/>
                            <GalleryStrip/>
                            <ContactSection/>
                            </div>}/>
                    </Routes>
                </BrowserRouter>
            </div>
            <CookieConsent
                enableDeclineButton
                onAccept={handleAcceptCookie}
                onDecline={handleDeclineCookie}
                buttonStyle={{ background: "#0d3e72", color: "#fff", border: "0", borderRadius: "5px", padding: "10px 20px", cursor: "pointer" }}
                declineButtonStyle={{ background: "#9c2e3e", color: "#fff", border: "0", borderRadius: "5px", padding: "10px 20px", cursor: "pointer" }}
            >
                This website uses cookies to enhance the user experience.
            </CookieConsent>
            <script src="/__/firebase/8.4.1/firebase-app.js"/>
            <script src="/__/firebase/init.js"/>
        </div>

    );
}

export default App;
